import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  people: [],
  groups: [],
  peopleStatus: "idle",
  error: null,
};

export const mgtSlice = createSlice({
  name: "people",
  initialState,
  reducers: {
    addPerson: (state, action) => {
      if (!state.people.some((p) => p.id === action.payload.id)) {
        state.people.push(action.payload);
      }
    },
    addGroup: (state, action) => {
      if (!state.groups.some((p) => p.id === action.payload.id)) {
        state.groups.push(action.payload);
      }
    },
  },
  extraReducers: {},
});

export const { addPerson, addGroup } = mgtSlice.actions;

export default mgtSlice.reducer;

export const selectAllPeople = (state) => state.people.people;
export const selectPerson = (state, action) => {
  const { email, userId } = action;
  if (userId) {
    return state.people.people.find((person) => person?.id === userId);
  } else {
    return state.people.people.find(
      (person) => person?.mail?.toLowerCase() === email?.toLowerCase()
    );
  }
};
export const selectAllGroups = (state) => state.people.groups;
export const selectGroup = (state, action) => {
  const { groupId } = action;
  return state.people.groups.find((group) => group?.id === groupId);
};
